import type { ComparisonConfig } from './ComparisonPage';
import { COMPARISON_TH_P3B } from './seo-comparison-p3b.th';


const SITEMINDER_TH: ComparisonConfig = {
  slug: 'hotelstack-vs-siteminder',
  competitorName: 'SiteMinder',
  heroTitle: 'HotelStack.io เทียบกับ SiteMinder',
  heroSubtitle: 'SiteMinder เป็นตัวจัดการช่องทางจากออสเตรเลียก่อตั้งในปี 2006 ที่เน้นการจัดจำหน่ายผ่าน OTA HotelStack.io มอบแพลตฟอร์มจัดการโรงแรมครบวงจร 36 โมดูลพร้อมจัดการช่องทาง PMS อาหารและเครื่องดื่ม เครื่องมือรายได้ และอื่นๆ — ทั้งหมดในราคาที่ต่ำกว่า',
  overviewComparison: [
    { label: 'ประเภทแพลตฟอร์ม', hotelstack: 'HMS ครบวงจร (36 โมดูล)', competitor: 'ตัวจัดการช่องทาง + ส่วนเสริม' },
    { label: 'ราคา', hotelstack: 'เริ่มต้น $49/เดือน', competitor: 'เริ่มต้น $99+/เดือน' },
    { label: 'PMS ในตัว', hotelstack: 'PMS เต็มรูปแบบรวมอยู่', competitor: 'Little Hotelier (แยก)' },
    { label: 'อาหารและเครื่องดื่ม / POS', hotelstack: 'ในตัว', competitor: 'ไม่มี' },
    { label: 'การจัดการรายได้', hotelstack: 'ขั้นสูง (ในตัว)', competitor: 'กฎ Yield พื้นฐาน' },
    { label: 'ระบบจองห้อง', hotelstack: 'BookMyRoom.io (ฟรี)', competitor: 'TheBookingButton (ส่วนเสริม)' },
  ],
  featureTable: [
    {
      category: 'ระบบจัดการโรงแรมหลัก',
      features: [
        { name: 'บอร์ดห้องพักแบบภาพ', hotelstack: true, competitor: false },
        { name: 'การจัดการการจอง', hotelstack: true, competitor: 'ผ่าน Little Hotelier' },
        { name: 'วิซาร์ดตรวจสอบกลางคืน', hotelstack: true, competitor: false },
        { name: 'การจัดการโฟลิโอแขก', hotelstack: true, competitor: false },
        { name: 'การจองแบบกลุ่ม', hotelstack: true, competitor: false },
        { name: 'พอร์ทัลเช็คอินออนไลน์', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'การจัดจำหน่ายและจัดการช่องทาง',
      features: [
        { name: 'ตัวจัดการช่องทาง (กว่า 100 OTA)', hotelstack: true, competitor: true },
        { name: 'การเชื่อมต่อ GDS', hotelstack: true, competitor: true },
        { name: 'การเชื่อมต่อ Metasearch', hotelstack: true, competitor: true },
        { name: 'การตรวจสอบ Rate Parity', hotelstack: true, competitor: true },
        { name: 'ระบบจองตรง', hotelstack: true, competitor: 'ส่วนเสริม' },
      ],
    },
    {
      category: 'การจัดการรายได้',
      features: [
        { name: 'กฎการกำหนดราคาไดนามิก', hotelstack: true, competitor: 'พื้นฐาน' },
        { name: 'ตัวจำลองรายได้ What-If', hotelstack: true, competitor: false },
        { name: 'ตัวตรวจสอบราคาคู่แข่ง', hotelstack: true, competitor: false },
        { name: 'การพยากรณ์อุปสงค์', hotelstack: true, competitor: false },
        { name: 'การวิเคราะห์ RevPAR', hotelstack: true, competitor: 'พื้นฐาน' },
      ],
    },
    {
      category: 'แขกและการดำเนินงาน',
      features: [
        { name: 'โปรไฟล์แขก 360 องศา', hotelstack: true, competitor: false },
        { name: 'การจัดการแม่บ้าน', hotelstack: true, competitor: false },
        { name: 'เทอร์มินัล POS', hotelstack: true, competitor: false },
        { name: 'โมดูลบริการห้องพัก', hotelstack: true, competitor: false },
        { name: 'การจัดตารางพนักงาน', hotelstack: true, competitor: false },
        { name: 'ใบสั่งงานซ่อมบำรุง', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'หลายสาขาและการปฏิบัติตามกฎหมาย',
      features: [
        { name: 'แดชบอร์ดเครือข่าย', hotelstack: true, competitor: 'จำกัด' },
        { name: 'การวิเคราะห์ข้ามสาขา', hotelstack: true, competitor: false },
        { name: 'การออกบิลหลายสกุลเงิน', hotelstack: true, competitor: 'จำกัด' },
        { name: 'การปฏิบัติตามกฎหมายภาษีท้องถิ่น', hotelstack: true, competitor: false },
        { name: 'การจัดการโปรแกรมสะสมคะแนน', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'ความยืดหยุ่นและออฟไลน์',
      features: [
        { name: 'PWA ที่ใช้งานออฟไลน์ได้', hotelstack: true, competitor: false },
        { name: 'คิวการเปลี่ยนแปลงแบบออฟไลน์', hotelstack: true, competitor: false },
        { name: 'ซิงค์เบื้องหลังเมื่อเชื่อมต่อใหม่', hotelstack: true, competitor: false },
        { name: 'การกระทบยอดที่ตรวจจับความขัดแย้ง', hotelstack: true, competitor: false },
        { name: 'ฟรอนต์เดสก์ที่ติดตั้งได้', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'ฝ่ายขายองค์กรและกรุ๊ป',
      features: [
        { name: 'การจัดการราคาองค์กร', hotelstack: true, competitor: false },
        { name: 'การจองแบบกรุ๊ปพร้อมรายชื่อห้องพัก', hotelstack: true, competitor: false },
        { name: 'รายงานอายุลูกหนี้และผลผลิต', hotelstack: true, competitor: false },
        { name: 'การจองร้านอาหาร', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'พนักงานและทรัพยากรบุคคล',
      features: [
        { name: 'ทำเนียบพนักงานและการจัดตารางเวร', hotelstack: true, competitor: false },
        { name: 'การประมวลผลเงินเดือน', hotelstack: true, competitor: false },
        { name: 'การลาและการลงเวลา', hotelstack: true, competitor: false },
        { name: 'การวิเคราะห์ผลการปฏิบัติงาน', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$99+',
    hotelstackNote: 'รวมทั้ง 36 โมดูล — PMS ตัวจัดการช่องทาง ระบบจอง อาหารและเครื่องดื่ม จัดการรายได้ ราคาตามภูมิภาคเป็น EUR, GBP, AED, INR, THB เริ่มต้นใช้งานและย้ายข้อมูลฟรี',
    competitorNote: 'ตัวจัดการช่องทางจาก $99+/เดือน PMS (Little Hotelier) และระบบจอง (TheBookingButton) เป็นผลิตภัณฑ์แยกพร้อมค่าธรรมเนียมแยก ไม่มีโมดูลอาหารและเครื่องดื่มหรือดำเนินงาน',
  },
  advantages: [
    'แพลตฟอร์มครบวงจรพร้อม 36 โมดูล เทียบกับ SiteMinder ที่เป็นแค่ตัวจัดการช่องทาง',
    'PMS เต็มรูปแบบในตัว — ไม่ต้องซื้อ Little Hotelier แยกสำหรับจัดการสถานที่',
    'อาหารและเครื่องดื่ม POS บริการห้องพัก และจัดการครัวรวมอยู่ไม่มีค่าใช้จ่ายเพิ่ม',
    'จัดการรายได้ขั้นสูงพร้อมราคาไดนามิก การพยากรณ์ และตัวจำลอง What-If',
    'CRM แขกพร้อมโปรไฟล์ 360 องศา โปรแกรมสะสมคะแนน และสื่อสารอัตโนมัติ',
    'เครื่องมือดำเนินงาน: แม่บ้าน ซ่อมบำรุง จัดตารางพนักงาน ทั้งหมดเชื่อมต่อกัน',
    'ราคาเริ่มต้นต่ำกว่า ($49 เทียบกับ $99+) พร้อมฟังก์ชันมากกว่าอย่างมาก',
    'เริ่มต้นใช้งานฟรีและย้ายข้อมูลพร้อมสนับสนุนเฉพาะ 24/7',
  ],
  verdict: {
    title: 'คำตัดสินของเรา',
    summary: 'SiteMinder โดดเด่นในฐานะตัวจัดการช่องทางแบบ standalone พร้อมการเชื่อมต่อ OTA ที่แข็งแกร่งที่สร้างมาเกือบสองทศวรรษ อย่างไรก็ตามไม่ใช่แพลตฟอร์มจัดการโรงแรมครบวงจร HotelStack.io รวมทุกอย่างที่ SiteMinder มีในด้านการจัดจำหน่ายพร้อม PMS เต็มรูปแบบ อาหารและเครื่องดื่ม/POS จัดการรายได้ CRM แขก และกว่า 25 โมดูลเพิ่มเติม — ทั้งหมดในสมาชิกเดียวราคาต่ำกว่า',
    bestFor: [
      'โรงแรมที่ต้องการแพลตฟอร์มเดียวแทนการรวม SiteMinder + PMS + POS',
      'สถานที่ที่ต้องการ PMS เต็มรูปแบบ อาหารและเครื่องดื่ม และเครื่องมือดำเนินงานเกินกว่าจัดการช่องทาง',
      'โรงแรมที่ต้องการจัดการรายได้ขั้นสูงและพยากรณ์อุปสงค์',
      'สถานที่ขนาดเล็กที่พบว่า SiteMinder แพงเกินไปสำหรับแค่การจัดจำหน่าย',
      'เครือโรงแรมหลายสาขาที่ต้องการจัดการส่วนกลางครอบคลุมทุกการดำเนินงาน',
    ],
  },
  faqItems: [
    { question: 'ฉันสามารถย้ายจาก SiteMinder มาที่ HotelStack.io ได้หรือไม่?', answer: 'ได้ ทีมย้ายข้อมูลของเราถ่ายโอนการเชื่อมต่อ OTA แผนราคา และข้อมูลการจอง HotelStack.io เชื่อมต่อกับ OTA เดียวกันกว่า 100 แห่งที่ SiteMinder รองรับ การย้ายข้อมูลฟรีและมักจะเสร็จภายใน 48 ชั่วโมงโดยไม่หยุดชะงัก' },
    { question: 'HotelStack.io เทียบเท่าความสามารถจัดการช่องทางของ SiteMinder หรือไม่?', answer: 'ใช่ HotelStack.io รวมตัวจัดการช่องทางเต็มรูปแบบเชื่อมต่อกับกว่า 100 OTA, GDS ผ่าน Amadeus และ Sabre และแพลตฟอร์ม Metasearch การตรวจสอบ Rate Parity และซิงค์คลังห้องพักแบบเรียลไทม์เป็นฟีเจอร์มาตรฐานในทุกแผน' },
    { question: 'ทำไมเลือก HotelStack.io แทน SiteMinder + Little Hotelier?', answer: 'การซื้อ SiteMinder (ตัวจัดการช่องทาง) รวมกับ Little Hotelier (PMS) รวมกับ TheBookingButton (ระบบจอง) แยกกันมีค่าใช้จ่ายมากกว่า HotelStack.io อย่างมาก และยังขาดอาหารและเครื่องดื่ม จัดการรายได้ จัดตารางพนักงาน และกว่า 20 โมดูลอื่นที่ HotelStack.io รวมอยู่' },
    { question: 'HotelStack.io เหมาะกับสถานที่ขนาดเล็กที่ใช้ SiteMinder อยู่หรือไม่?', answer: 'แน่นอน แผน Starter ของเราที่ $49/เดือนรวมทั้ง 36 โมดูลไม่จำกัดฟีเจอร์ สถานที่ขนาดเล็กจะได้แพลตฟอร์มจัดการครบวงจรแทนที่จะเป็นแค่ตัวจัดการช่องทาง ในต้นทุนรวมที่ต่ำกว่า SiteMinder เพียงอย่างเดียว' },
  ],
};

const ROOMRACCOON_TH: ComparisonConfig = {
  slug: 'hotelstack-vs-roomraccoon',
  competitorName: 'RoomRaccoon',
  heroTitle: 'HotelStack.io เทียบกับ RoomRaccoon',
  heroSubtitle: 'RoomRaccoon เป็น HMS ขับเคลื่อนด้วย AI จากเนเธอร์แลนด์ที่มุ่งเป้าโรงแรมบูทีคและขนาดเล็ก HotelStack.io ขยายจากบูทีคสู่องค์กรพร้อม 36 โมดูล จัดการรายได้ขั้นสูง อาหารและเครื่องดื่ม/POS เต็มรูปแบบ และรองรับหลายสาขา — ทั้งหมดในราคาที่แข่งขันได้',
  overviewComparison: [
    { label: 'โมดูลทั้งหมด', hotelstack: '36 โมดูลแบบบูรณาการ', competitor: 'กว่า 10 โมดูล' },
    { label: 'ราคา', hotelstack: 'เริ่มต้น $49/เดือน', competitor: 'เริ่มต้น $79+/เดือน' },
    { label: 'กลุ่มเป้าหมาย', hotelstack: 'SMB ถึงองค์กร', competitor: 'บูทีค / โรงแรมเล็ก' },
    { label: 'อาหารและเครื่องดื่ม / POS', hotelstack: 'ในตัว', competitor: 'ไม่มี' },
    { label: 'หลายสาขา', hotelstack: 'จัดการเครือข่ายเต็มรูปแบบ', competitor: 'จำกัด' },
    { label: 'การเข้าถึงทั่วโลก', hotelstack: 'กว่า 40 ประเทศ', competitor: 'ยุโรปเป็นหลัก' },
  ],
  featureTable: [
    {
      category: 'ระบบจัดการโรงแรมหลัก',
      features: [
        { name: 'บอร์ดห้องพักแบบภาพ', hotelstack: true, competitor: true },
        { name: 'การจัดการการจอง', hotelstack: true, competitor: true },
        { name: 'วิซาร์ดตรวจสอบกลางคืน', hotelstack: true, competitor: true },
        { name: 'การจัดการโฟลิโอแขก', hotelstack: true, competitor: true },
        { name: 'การจองแบบกลุ่ม', hotelstack: true, competitor: 'จำกัด' },
        { name: 'พอร์ทัลเช็คอินออนไลน์', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'รายได้และการจัดจำหน่าย',
      features: [
        { name: 'ตัวจัดการช่องทาง (กว่า 100 OTA)', hotelstack: true, competitor: 'OTA น้อยกว่า' },
        { name: 'จัดการ Yield ขับเคลื่อนด้วย AI', hotelstack: true, competitor: true },
        { name: 'กฎการกำหนดราคาไดนามิก', hotelstack: true, competitor: 'พื้นฐาน' },
        { name: 'ตัวจำลองรายได้ What-If', hotelstack: true, competitor: false },
        { name: 'ตัวตรวจสอบราคาคู่แข่ง', hotelstack: true, competitor: false },
        { name: 'การพยากรณ์อุปสงค์', hotelstack: true, competitor: 'พื้นฐาน' },
      ],
    },
    {
      category: 'การจัดการแขก',
      features: [
        { name: 'โปรไฟล์แขก 360 องศา', hotelstack: true, competitor: 'พื้นฐาน' },
        { name: 'การจัดการโปรแกรมสะสมคะแนน', hotelstack: true, competitor: false },
        { name: 'ระบบอัตโนมัติสื่อสารกับแขก', hotelstack: true, competitor: true },
        { name: 'การวิเคราะห์การใช้จ่ายของแขก', hotelstack: true, competitor: false },
        { name: 'อัปโหลดและยืนยันตัวตน', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'อาหารและเครื่องดื่ม & การดำเนินงาน',
      features: [
        { name: 'เทอร์มินัล POS', hotelstack: true, competitor: false },
        { name: 'โมดูลบริการห้องพัก', hotelstack: true, competitor: false },
        { name: 'ระบบแสดงผลครัว', hotelstack: true, competitor: false },
        { name: 'การจัดการแม่บ้าน', hotelstack: true, competitor: true },
        { name: 'ใบสั่งงานซ่อมบำรุง', hotelstack: true, competitor: false },
        { name: 'การจัดตารางพนักงาน', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'องค์กรและหลายสาขา',
      features: [
        { name: 'แดชบอร์ดเครือข่าย', hotelstack: true, competitor: 'จำกัด' },
        { name: 'การวิเคราะห์ข้ามสาขา', hotelstack: true, competitor: false },
        { name: 'การจัดการราคาส่วนกลาง', hotelstack: true, competitor: false },
        { name: 'การบังคับมาตรฐานแบรนด์', hotelstack: true, competitor: false },
        { name: 'ผู้ดูแลระบบระดับแพลตฟอร์ม', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'ความยืดหยุ่นและออฟไลน์',
      features: [
        { name: 'PWA ที่ใช้งานออฟไลน์ได้', hotelstack: true, competitor: false },
        { name: 'คิวการเปลี่ยนแปลงแบบออฟไลน์', hotelstack: true, competitor: false },
        { name: 'ซิงค์เบื้องหลังเมื่อเชื่อมต่อใหม่', hotelstack: true, competitor: false },
        { name: 'การกระทบยอดที่ตรวจจับความขัดแย้ง', hotelstack: true, competitor: false },
        { name: 'ฟรอนต์เดสก์ที่ติดตั้งได้', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'ฝ่ายขายองค์กรและกรุ๊ป',
      features: [
        { name: 'การจัดการราคาองค์กร', hotelstack: true, competitor: false },
        { name: 'การจองแบบกรุ๊ปพร้อมรายชื่อห้องพัก', hotelstack: true, competitor: 'จำกัด' },
        { name: 'รายงานอายุลูกหนี้และผลผลิต', hotelstack: true, competitor: false },
        { name: 'การจองร้านอาหาร', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'พนักงานและทรัพยากรบุคคล',
      features: [
        { name: 'ทำเนียบพนักงานและการจัดตารางเวร', hotelstack: true, competitor: false },
        { name: 'การประมวลผลเงินเดือน', hotelstack: true, competitor: false },
        { name: 'การลาและการลงเวลา', hotelstack: true, competitor: false },
        { name: 'การวิเคราะห์ผลการปฏิบัติงาน', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$79+',
    hotelstackNote: 'รวมทั้ง 36 โมดูล รองรับจากบูทีค 10 ห้องถึงองค์กรกว่า 500 ห้อง ราคาตามภูมิภาคเป็น EUR, GBP, AED, INR, THB เริ่มต้นใช้งานและย้ายข้อมูลฟรี',
    competitorNote: 'ราคาแบบขั้นจาก EUR 79+/เดือน ฟีเจอร์ขั้นสูงล็อคอยู่ในแผนสูงกว่า ความสามารถองค์กรและหลายสาขาจำกัด',
  },
  advantages: [
    'โมดูลมากกว่าสามเท่า (36 เทียบกับ 10+) ไม่มีฟีเจอร์ล็อคหลังแผนพรีเมียม',
    'ขยายจากบูทีคสู่องค์กร — RoomRaccoon จำกัดแค่สถานที่ขนาดเล็ก/กลาง',
    'โมดูลอาหารและเครื่องดื่มสมบูรณ์พร้อม POS บริการห้องพัก และจัดการครัว',
    'จัดการเครือโรงแรมหลายสาขาเต็มรูปแบบพร้อมการวิเคราะห์ส่วนกลางและจัดจำหน่ายราคา',
    'จัดการรายได้ขั้นสูงเกินกว่า AI yield พื้นฐาน — รวมการพยากรณ์และตัวจำลอง',
    'จัดการโปรแกรมสะสมคะแนนเพื่อรักษาแขกและเพิ่มการจองซ้ำ',
    'เข้าถึงทั่วโลกกว่า 40 ประเทศ เทียบกับ RoomRaccoon ที่เน้นยุโรป',
    'จัดการพนักงานพร้อมจัดตาราง เงินเดือน และติดตามประสิทธิภาพ',
  ],
  verdict: {
    title: 'คำตัดสินของเรา',
    summary: 'RoomRaccoon เป็นทางเลือกที่ดีสำหรับโรงแรมบูทีคขนาดเล็กในยุโรปที่ต้องการ PMS ขับเคลื่อนด้วย AI พร้อมอินเทอร์เฟซทันสมัย อย่างไรก็ตามขาดความลึก ความสามารถในการขยาย และขอบเขตดำเนินงานที่สถานที่กำลังเติบโตต้องการ HotelStack.io มอบทุกอย่างที่ RoomRaccoon มีบวกอาหารและเครื่องดื่ม/POS จัดการหลายสาขาระดับองค์กร เครื่องมือรายได้ขั้นสูง และปฏิบัติตามกฎหมายทั่วโลก — ทำให้เป็นการลงทุนระยะยาวที่แข็งแกร่งกว่า',
    bestFor: [
      'โรงแรมบูทีคที่ต้องการฟีเจอร์ระดับองค์กรไม่ต้องจ่ายราคาองค์กร',
      'สถานที่ที่ต้องการอาหารและเครื่องดื่ม POS และจัดการครัวใน HMS',
      'โรงแรมที่วางแผนขยายจากสาขาเดียวสู่เครือโรงแรมหลายสาขา',
      'สถานที่นอกยุโรปที่ต้องการปฏิบัติตามกฎหมายและจัดจำหน่ายทั่วโลก',
      'โรงแรมที่ต้องการจัดการรายได้ขั้นสูงเกินกว่า yield optimization พื้นฐาน',
    ],
  },
  faqItems: [
    { question: 'ฉันสามารถย้ายจาก RoomRaccoon มาที่ HotelStack.io ได้หรือไม่?', answer: 'ได้ ทีมย้ายข้อมูลของเราดำเนินการถ่ายโอนข้อมูลทั้งหมดจาก RoomRaccoon รวมถึงโปรไฟล์แขก ประวัติการจอง แผนราคา และการตั้งค่าห้อง การย้ายข้อมูลฟรีและมักจะเสร็จภายใน 48 ชั่วโมงโดยไม่หยุดชะงัก' },
    { question: 'HotelStack.io มีฟีเจอร์ขับเคลื่อนด้วย AI เหมือน RoomRaccoon หรือไม่?', answer: 'ใช่ HotelStack.io รวมจัดการ yield อัจฉริยะ พยากรณ์อุปสงค์ กฎราคาไดนามิก และตัวจำลองรายได้ เครื่องมือ AI ของเราเกินกว่า yield optimization พื้นฐานรวมถึงตรวจสอบคู่แข่งและวางแผนสถานการณ์ What-If' },
    { question: 'HotelStack.io เหมาะกับโรงแรมบูทีคเหมือน RoomRaccoon หรือไม่?', answer: 'แน่นอน แผน Starter ของเราออกแบบมาสำหรับสถานที่ทุกขนาดรวมถึงโรงแรมบูทีค คุณจะได้ทั้ง 36 โมดูลตั้งแต่วันแรกไม่จำกัดฟีเจอร์ และ UI หรูหราสีเข้มทันสมัยมอบประสบการณ์สง่างามที่โรงแรมบูทีคชื่นชอบ' },
    { question: 'HotelStack.io จัดการหลายสาขาเทียบกับ RoomRaccoon อย่างไร?', answer: 'HotelStack.io รวมแดชบอร์ดจัดการเครือข่ายเต็มรูปแบบพร้อมการวิเคราะห์ข้ามสาขา จัดจำหน่ายราคาส่วนกลาง มาตรฐานแบรนด์ และรายงานรวม RoomRaccoon มีการรองรับหลายสาขาจำกัด ทำให้ HotelStack.io เป็นทางเลือกที่ดีกว่าสำหรับกลุ่มโรงแรมที่กำลังเติบโต' },
  ],
};

export const COMPARISON_TH_P3: Record<string, ComparisonConfig> = {
  'hotelstack-vs-siteminder': SITEMINDER_TH,
  'hotelstack-vs-roomraccoon': ROOMRACCOON_TH,
  ...COMPARISON_TH_P3B,
};
